module.exports = __webpack_public_path__ + "static/agile-205da7b5c3baaadf54f2be803672911c.svg";